import {Component, EventEmitter} from '@angular/core';
import {ModalComponent} from '../modal-service.service';

@Component({
    selector: 'nlr-amend-modal',
    imports: [],
    templateUrl: './amend-replace-latest-modal.component.html',
    styleUrls: ['../modal.scss', './amend-replace-latest-modal.component.scss']
})
export class AmendReplaceLatestModalComponent implements ModalComponent {
    modalClosed: EventEmitter<string | boolean> = new EventEmitter<string | boolean>();
    modalSize: string = 'modal-lg';
    title: string;
    message: string;

    constructor() {}

    close() {
        this.modalClosed.emit('close');
    }

    loadChosenVerion() {
        this.modalClosed.emit(false);
    }

    loadLatestVersion() {
        this.modalClosed.emit(true);
    }
}
